<section class="main">
  <div class="">
    <h3>
      Manage clients
    </h3>

    <div class="filter d-flex justify-content-between align-items-center">
      <div class="inputSearch d-flex justify-content-between align-items-center">
        <input type="search" (input)="clientSearch($event)" class="form-control" placeholder="Search clients" />
        <!-- <a (click)="clientLogs()">Clients log</a> -->
      </div>
      <!-- <div class="dropDowen">
        <div class="dropdown mb-0 ">
          <button
            class="btn  dropdown-toggle text-truncate"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            All Clients
            <img src="assets/images/mangeunit/arrow.png" />
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <a class="dropdown-item" style="cursor: pointer">one</a>
            </li>
          </ul>
        </div>
      </div> -->
    </div>

    <div id="cardPrint">
      <div class="cards print" *ngFor="let item of dataPrint">
        <div class="front" style="text-align: center">
          <div>
            <h4>{{ item.type | uppercase }}</h4>
            <img [src]="item.image" alt="Avatar" />
            <hr />
            <div class="containerr">
              <h1>{{ item.name | uppercase }}</h1>
              <p *ngIf="item.unitName != ''">Unit : {{ item.unitName }}</p>
              <!-- <p>Zone : {{ item.villageName }}</p> -->
            </div>
          </div>
        </div>
        <div class="back">
          <div>
            <img [src]="item.image1" />
          </div>
        </div>
      </div>
    </div>

    <button id="printButton" class="cardPrint" [useExistingCss]="true" printSectionId="cardPrint" ngxPrint>
      print
    </button>

    <!-- cards -->
    <div class="mt-5">
      <div class="row">
        <div class="col-md-4 col-12" *ngFor="let item of all_clients">
          <div class="clientsCard " [ngClass]="{
            clientsCardWhenBlock: item.cancelled === true
          }">
            <div class="row info">
              <div class="col-4">
                <img *ngIf="item.photo" class="user img-fluid"
                  [src]="item.photo.changingThisBreaksApplicationSecurity" />
                <img *ngIf="!item.photo" class="user img-fluid" src="assets/images/avatar.png" />
              </div>
              <div class="col-7 p-0 ownerInfo">
                <p class="mb-2" style="cursor: pointer" (click)="viewClient(item)">
                  <img *ngIf="item.verified == true" src="assets/images/mangeunit/circle_check.png" />
                  {{ item.name }}
                </p>
                <div>
                  <span class="hint">{{ item.type.name }}</span>

                  <span *ngIf="item.verified == true" class="hint">Verified</span>
                  <span *ngIf="item.activated == true" class="hint">Activated</span>
                  <span (click)="goToUnit(unit.name)" style="cursor: pointer" *ngFor="let unit of item.unit"
                    class="hint">UN:{{ unit.name }}</span>
                  <span *ngIf="item.phone_number" class="hint">{{
                    item.phone_number
                  }}</span>
                  <span *ngIf="item.email" class="hint">{{ item.email }}</span>
                </div>
              </div>
              <div class="col-1 dots">
                <mat-menu #menu="matMenu">
                  <p (click)="editClient(item)" class="menuItem" mat-menu-item>Edit</p>
                  <p *ngIf="item.cancelled === false" (click)="openBlockClient('block', item)" class="menuItem"
                    mat-menu-item>
                    Block
                  </p>
                  <p *ngIf="item.cancelled === true" (click)="openBlockClient('unblock', item)" class="menuItem"
                    mat-menu-item>
                    Active
                  </p>

                  <p (click)="openDeletClient(item)" class="menuItem" mat-menu-item>Delete</p>

                </mat-menu>
                <img [matMenuTriggerFor]="menu" src="assets/images/mangeunit/dots.png" />
              </div>
            </div>

            <div class="mt-4 icons d-flex align-items-center justify-content-between">
              <img (click)="genrateInvtaion(item)" matTooltip="Invitations " matTooltipClass="example-tooltip-uppercase"
                [matTooltipPosition]="'above'" src="assets/images/mangeunit/Group 162.png" />

              <img (click)="blockUnitGates(item.id)" mat-raised-button matTooltip="Gate access"
                matTooltipClass="example-tooltip-uppercase" [matTooltipPosition]="'above'" class="icon2"
                src="assets/images/mangeunit/Group 136.png" />

              <img (click)="addCard(item)" mat-raised-button matTooltip="Activate"
                matTooltipClass="example-tooltip-uppercase" [matTooltipPosition]="'above'" class="icon3"
                src="assets/images/mangeunit/Group 160.png" />

              <div class="notes">
                <p *ngIf="item.notes.length != 0">
                  <span>{{ item.notes.length}}</span>
                </p>
                <img (click)="addNote('client', item.id)" mat-raised-button matTooltip="Add/Show Note"
                  matTooltipClass="example-tooltip-uppercase" [matTooltipPosition]="'above'"
                  src="assets/images/mangeunit/Group 170.png" />
              </div>

              <img *ngIf="!item.printed" (click)="print_card(item)" mat-raised-button matTooltip="Print"
                matTooltipClass="example-tooltip-uppercase" [matTooltipPosition]="'above'"
                src="assets/images/mangeunit/5.png" />

              <img *ngIf="item.printed" (click)="print_card(item)" mat-raised-button matTooltip="Print Again"
                matTooltipClass="example-tooltip-uppercase" [matTooltipPosition]="'above'"
                src="assets/images/mangeunit/greenPrint.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="all_clients.length != 0">
    <mat-paginator (page)="handlePageEvent($event)" [pageIndex]="pageIndex" [length]="5003" [pageSize]="page_size"
      [pageSizeOptions]="[10, 25, 100, 150, 200]" aria-label="Select page">
    </mat-paginator>
  </div>
</section>

<!-- blocked Modal -->

<button id="btn4" style="display: none" type="button" class="btn btn-primary" data-bs-toggle="modal"
  data-bs-target="#exampleModal4">
  Launch demo modal
</button>

<div class="modal fade" id="exampleModal4" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title" id="exampleModalLabel">
          {{ blockClientTitle }} client
        </h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Are you sure you want to {{ blockClientTitle }} the client?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="blockClient()" data-bs-dismiss="modal">
          {{ blockClientTitle }} Client
        </button>
      </div>
    </div>
  </div>
</div>

<!-- deleted model -->


<button id="btn3" style="display: none" type="button" class="btn btn-primary" data-bs-toggle="modal"
  data-bs-target="#exampleModal3">
  Launch demo modal
</button>

<!-- Modal -->
<div class="modal fade" id="exampleModal3" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title" id="exampleModalLabel">Delet client</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Are you sure you want to delet the client?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="DeleleClient()" data-bs-dismiss="modal">
          Delet client
        </button>
      </div>
    </div>
  </div>
</div>